import { AppRegistry } from 'react-native';
import { createK18n } from '@/common/i18n';
import lang from '@k18n/kibt-fe-shop-c-lang/tags/productdetail/index.json';
import { CreateMpaPage } from '../../CreateMpaPage';
import Detail from './views/content';

createK18n(lang);

AppRegistry.registerComponent(
    'Detail',
    CreateMpaPage({
        app: Detail,
        // autoPvPageMap: ({ page, params }) => {
        //     // MPA直接返回不需要根据路由判断
        //     return { page: 'PRODUCT_DETAILS', asyncParams: true };
        // },
    }),
);

AppRegistry.runApplication('Detail', {
    initialProps: {
        sourceType: 'web',
        rootTag: document.getElementById('root'),
    },
    rootTag: document.getElementById('root'),
});
